import React, { Component } from 'react'

class PageNotFound extends Component {
  
  render() {
    return (
      <div>404 not found</div>
    )
  }
}

export default PageNotFound


// WEBPACK FOOTER //
// ./src/components/page-not-found/index.jsx